export const DEFAULT_HCAPTCHA_SITE_KEY = '6ccc1488-45d8-4ffc-b2c6-a6bc201a16ea';
export const PLAYWRIGHT_HCAPTCHA_TOKEN = 'playwright-hcaptcha-token';
export const PRODUCTION_SMOKE_HCAPTCHA_SITE_KEY = '10000000-ffff-ffff-ffff-000000000001';
export const PRODUCTION_SMOKE_HCAPTCHA_TOKEN = '10000000-aaaa-bbbb-cccc-000000000001';
export const PRODUCTION_SMOKE_SIGNUP_PATH = '/api/v1/signup';
export const PRODUCTION_SMOKE_BROKEN_SIGNUP_PATH = '/api/v1/__signup_smoke_deliberately_broken__';

export type ProductionSignupSmokeConfig = {
  secret: string;
  signupPath: typeof PRODUCTION_SMOKE_SIGNUP_PATH | typeof PRODUCTION_SMOKE_BROKEN_SIGNUP_PATH;
};

declare global {
  interface Window {
    __TRINI_SIGNUP_SMOKE__?: {
      secret?: unknown;
      signupPath?: unknown;
    };
  }
}

export type HcaptchaEnv = Partial<{
  VITE_HCAPTCHA_SITE_KEY: string;
  VITE_HCAPTCHA_TEST_MODE: string;
}>;

function getImportMetaEnv(): HcaptchaEnv {
  return import.meta.env as unknown as HcaptchaEnv;
}

export function getHcaptchaSiteKey(env: HcaptchaEnv = getImportMetaEnv()): string {
  return env.VITE_HCAPTCHA_SITE_KEY?.trim() || DEFAULT_HCAPTCHA_SITE_KEY;
}

export function isHcaptchaTestMode(env: HcaptchaEnv = getImportMetaEnv()): boolean {
  return env.VITE_HCAPTCHA_TEST_MODE === 'true';
}

export function readProductionSignupSmokeConfig(): ProductionSignupSmokeConfig | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const candidate = window.__TRINI_SIGNUP_SMOKE__;
  const secret = typeof candidate?.secret === 'string' ? candidate.secret.trim() : '';
  const signupPath = candidate?.signupPath;

  if (!secret) {
    return null;
  }

  if (
    signupPath !== PRODUCTION_SMOKE_SIGNUP_PATH &&
    signupPath !== PRODUCTION_SMOKE_BROKEN_SIGNUP_PATH
  ) {
    return null;
  }

  return { secret, signupPath };
}
